import {  notification } from 'antd';

const RoseAlert = (type, message, title) => {
    notification[type]({
      message: title ? title : 'Notification',
      description: message,
});
}

export default RoseAlert;